const DefineIcon = ({ className, isSelected = false }) => {
  const fillColor = isSelected
    ? 'var(--forbrand-primary)'
    : 'var(--forbrand-secondary)'

  return (
    <div
      className={`${className} flex items-center justify-center w-[32px] h-[32px]`}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill={fillColor}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 14V2H8V6H12V13H13V5.04295L8.95705 1H3V15H12.2998L13 14H4ZM9 2.45705L11.5429 5H9V2.45705ZM9.1198 11L8.54245 12H5V11H9.1198ZM11 9.5H5V8.5H11V9.5Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}

export default DefineIcon
